import script from "./PensionPotsViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PensionPotsViewer.vue?vue&type=script&setup=true&lang=ts"

import "./PensionPotsViewer.vue?vue&type=style&index=0&id=6cdc42e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cdc42e8"]])

export default __exports__